import QueryEmployeeFavourites from "graphql/queries/QueryEmployeeFavourites";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchFavourites = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'employee_favourites', QueryEmployeeFavourites, {
			resultPath: [ 'employee_favourites' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchFavourites
